import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { snakeToCamel } from "caseparser";

export const gymsApi = api
  .enhanceEndpoints({ addTagTypes: ["access"] })
  .injectEndpoints({
    overrideExisting: false,
    endpoints: (builder) => ({
      fetchAccess: builder.mutation({
        query: (params) => ({
          url: "access",
          method: RequestMethod.GET,
          params,
        }),
      }),
      installations: builder.query({
        query: (params) => ({
          url: "/access/installations",
          method: RequestMethod.GET,
          params,
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
      }),
      lathes: builder.query({
        query: (params) => ({
          url: "/access/lathes",
          method: RequestMethod.GET,
          params,
        }),
        transformResponse: (response: any) => snakeToCamel(response.data),
      }),
      openDoorRequest: builder.mutation({
        query: (params) => ({
          url: "/access/open-door-request",
          method: RequestMethod.POST,
          body: params,
        }),
      }),
      accessUserManual: builder.mutation({
        query: (params) => ({
          url: "/access/access-user-manual",
          method: RequestMethod.POST,
          body: params,
        }),
      }),
    }),
  });

export const {
  useFetchAccessMutation,
  useInstallationsQuery,
  useLathesQuery,
  useOpenDoorRequestMutation,
  useAccessUserManualMutation,
} = gymsApi;
